import { useEffect, useState } from 'react'

import { useDebounce } from './useDebounce'
import { usePermissions } from '@/hooks/usePermissions'

import { useUpdateDeviceMutation } from '@/graphql/generated/hooks'
import { UpdateDeviceInput } from '@/graphql/generated/schemas'

import { DeviceI } from '../types/types'

const REFETCH_QUERIES = ['FloorDevicesCount']

export const useUpdateDevice = (floorId: string) => {
  const { shouldEnableUpdateDevice } = usePermissions()

  const [update, { error }] = useUpdateDeviceMutation()

  const [updateInput, setUpdateInput] = useState<UpdateDeviceInput>(null)
  const debouncedUpdateInput = useDebounce(updateInput, 1500)

  const updateDevice = (
    newData: DeviceI,
    devicePositionValid: boolean,
    skipDebounce?: boolean
  ) => {
    if (!shouldEnableUpdateDevice) return
    const mutationInput = {
      id: newData.id,
      x: devicePositionValid ? newData.x : null,
      y: devicePositionValid ? newData.y : null,
      bearing: newData.rotation,
      fieldOfView: newData.angle,
      visibilityRange: newData.distance,
      floorId: floorId,
    }

    if (skipDebounce) {
      update({
        variables: {
          input: mutationInput,
        },
        refetchQueries: REFETCH_QUERIES,
      })
    } else {
      setUpdateInput(mutationInput)
    }
  }

  useEffect(() => {
    if (!debouncedUpdateInput) return
    update({
      variables: {
        input: debouncedUpdateInput,
      },
      refetchQueries: REFETCH_QUERIES,
    })
  }, [debouncedUpdateInput])

  return { updateDevice, error }
}
